"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchRequestAcknowledgementType = void 0;
var LaunchRequestAcknowledgementType;
(function (LaunchRequestAcknowledgementType) {
    LaunchRequestAcknowledgementType["StreamingAgentReady"] = "streamingAgentReady";
    LaunchRequestAcknowledgementType["StreamingAgentFinished"] = "streamingAgentFinished";
    LaunchRequestAcknowledgementType["WebRTCConnectionFailed"] = "webRTCConnectionFailed"; // webRTC connection has failed
})(LaunchRequestAcknowledgementType = exports.LaunchRequestAcknowledgementType || (exports.LaunchRequestAcknowledgementType = {}));
